<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import CreditCardForm from '@/components/credit-cards/CreditCardForm.vue';
    import type { SharedData } from '@/types';
    import { useI18n } from 'vue-i18n';
    import { usePage } from '@inertiajs/vue3';
    import { computed } from 'vue';

    const { t } = useI18n();
    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const form = useForm({
        name: '',
        number: '',
        type: '',
        last_used: '',
        employee_ids: [],
        user_ids: [],
    });
</script>

<template>
    <DialogForm
        type="create"
        :form="form"
        :route="route('v2.credit-cards.store', { company: selectedCompanyId })"
        :query-key="['credit-cards']"
        title="credit-cards.create.title"
        button-text="credit-cards.create.title"
        :success-message-translated="t('credit-cards.create.success', { name: form.name })"
        :transform="
            (data) => ({
                ...data,
                number: data.number.replace(/\s/g, ''),
            })
        "
    >
        <CreditCardForm :form="form" />
    </DialogForm>
</template>
